(function () {
    'use strict';

    angular
        .module('partner')
        .config(PartnerRoute);

    PartnerRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function PartnerRoute ($stateProvider) {
        $stateProvider
            .state('root.partner', {
                abstract: true,
                url: '/partner',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                },
            })
            .state ('root.partner.dashboard', {
                url: '/dashboard',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/partner/dashboard/dashboard.html',
                        controller: 'PartnerDashboardController',
                        controllerAs: 'partnerDashboard'
                        //resolve: {
                            // partnersList: ['ManagePartnersService', function(ManagePartnersService) {
                            //     return ManagePartnersService.getAll();
                            // }]
                        //}
                    }
                }
            })
            .state('root.partner.virtualFairs', {
                abstract: true,
                url: '/virtualfairs',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                },
            })
            .state ('root.partner.virtualFairs.students', {
                url: '/students',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/partner/dashboard/dashboard.html',
                        controller: 'PartnerDashboardController',
                        controllerAs: 'partnerDashboard'
                        //resolve: {
                            // partnersList: ['ManagePartnersService', function(ManagePartnersService) {
                            //     return ManagePartnersService.getAll();
                            // }]
                        //}
                    }
                }
            });
    }
})();